import React, { useEffect, useState, useRef } from "react";

const CourseData = [
  {
    id: 1,
    title: "Career Management",
    subtitle: "The Science of the Soul",
    quote:
      "This program completely transformed my career path. The mentorship and hands-on projects were invaluable.",
    image: "/assets/Courses/Discover_Yourself.jpg",
    price: "₹499",
    duration: "4 Sessions",
    details:
      "A profound journey into self-discovery, covering the nature of the mind, the existence of God, and the practical application of spirituality in modern life.",
    perks: ["Digital Certificate", "Meditation Guide", "Personal Mentorship"],
  },
  {
    id: 2,
    title: "Lifestyle Management",
    subtitle: "Logic meets Wisdom",
    quote:
      "The skills I gained here were directly applicable to my job from day one. Highly recommended for aspiring developers.",
    image: "/assets/Courses/Spiritual_Scientist.jpeg",
    price: "₹799",
    duration: "6 Sessions",
    details:
      "Analyze the universe through both scientific and spiritual lenses. Perfect for logical thinkers looking for deeper meaning.",
    perks: ["Resource Library", "Live Q&A", "Community Access"],
  },
  {
    id: 3,
    title: "Lifestyle Management(Part-2)",
    subtitle: "Logic meets Wisdom",
    quote:
      "The skills I gained here were directly applicable to my job from day one. Highly recommended for aspiring developers.",
    image: "/assets/Courses/Positive_Thinker.jpeg",
    price: "₹1299",
    duration: "6 Sessions",
    details:
      "Analyze the universe through both scientific and spiritual lenses. Perfect for logical thinkers looking for deeper meaning.",
    perks: ["Resource Library", "Live Q&A", "Community Access"],
  },
  {
    id: 4,
    title: "Leadership Program",
    subtitle: "Logic meets Wisdom",
    quote:
      "The skills I gained here were directly applicable to my job from day one. Highly recommended for aspiring developers.",
    image: "/assets/Courses/LTP.jpg",
    price: "₹799",
    duration: "6 Sessions",
    details:
      "Analyze the universe through both scientific and spiritual lenses. Perfect for logical thinkers looking for deeper meaning.",
    perks: ["Resource Library", "Live Q&A", "Community Access"],
  },
];

const CourseCatalog = () => {
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [isMounted, setIsMounted] = useState(false);
  const sliderRef = useRef(null);

  useEffect(() => {
    setIsMounted(true);
    // ... (Your existing auto-scroll logic remains the same)
  }, []);

  const openDetails = (course) => setSelectedCourse(course);
  const closeDetails = () => setSelectedCourse(null);

  return (
    <div className="catalog-wrapper">
      <div className="alumni-section-container">
        {/* Header Section */}
        <div className="alumni-header">
          <div className={`tag-container ${isMounted ? "fade-in-up" : ""}`}>
            <span className="tag">🎓 Our Curriculum</span>
          </div>
          <h1 className={`alumni-title ${isMounted ? "fade-in-up" : ""}`}>
            Ignite Your Inner Potential
          </h1>
        </div>

        {/* Horizontal Slider */}
        <div className="alumni-slider-wrapper">
          <div className="alumni-slider" ref={sliderRef}>
            {CourseData.map((course) => (
              <div
                className="alumni-card cursor-pointer"
                key={course.id}
                onClick={() => openDetails(course)}
              >
                <div className="alumni-image-wrapper">
                  <img
                    src={course.image}
                    alt={course.title}
                    className="alumni-image"
                  />
                  <div className="card-overlay-btn">View Details</div>
                </div>
                <div className="alumni-content">
                  <p className="alumni-name">{course.title}</p>
                  <p className="alumni-quote">
                    "{course.quote.substring(0, 80)}..."
                  </p>
                  <div className="alumni-info">
                    <span className="price-tag">{course.price}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="slider-fade-left"></div>
          <div className="slider-fade-right"></div>
        </div>
      </div>

      {/* --- PREMIUM DETAIL OVERLAY --- */}
      {selectedCourse && (
        <div className="details-overlay" onClick={closeDetails}>
          <div className="details-modal" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={closeDetails}>
              &times;
            </button>

            <div className="modal-grid">
              <div className="modal-image-side">
                <img src={selectedCourse.image} alt={selectedCourse.title} />
              </div>

              <div className="modal-info-side">
                <span className="modal-duration">
                  ⏱ {selectedCourse.duration}
                </span>
                <h2 className="modal-title">{selectedCourse.title}</h2>
                <h4 className="modal-subtitle">{selectedCourse.subtitle}</h4>

                <p className="modal-description">{selectedCourse.details}</p>

                <div className="perks-list">
                  {selectedCourse.perks.map((perk, i) => (
                    <span key={i} className="perk-tag">
                      ✦ {perk}
                    </span>
                  ))}
                </div>

                <div className="modal-footer">
                  <div className="modal-price">
                    <span className="price-label">Investment</span>
                    <span className="price-amount">{selectedCourse.price}</span>
                  </div>
                  <button className="enroll-now-btn">Enroll Now</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CourseCatalog;
